/* eslint-disable no-unused-vars */
import React, { useEffect, useState, Suspense } from 'react'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import { useEligibility } from '../../../context/EligibilityContext'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'

// import DraftForm from '../../../utils/formDraft'
// import { useAuthentication } from '../../../context/authenticationContext'
// servicio para crear los registros
// import { createForm } from '../../../services/Forms/create'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

import ElegibilidadSec1 from './ElegibilidadSec1'
import ElegibilidadSec2 from './ElegibilidadSec2'
import ElegibilidadSec3 from './ElegibilidadSec3'
import ElegibilidadSec4 from './ElegibilidadSec4'
// import GridCrud from './Grid'
import ElegibilidadSec5 from './ElegibilidadSec5'
import ElegibilidadSec6 from './ElegibilidadSec6'

// const StepWizard = React.lazy(() => import('react-step-wizard'))
import { useForm } from '../../../context/formContext'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import { useAuthentication } from '../../../context/authenticationContext'
import { saveElegibilityForm } from '../../../services/Elegibilidad/create'

const ElegibilidadForm = () => {
  const [state, dispatch] = useEligibility()

  // const { step, setFetchRequest } = useForm()
  // const [state, useStates] = useState({ step: 1 })
  // const state = { step: 1 }
  const { IdIFIToken } = useAuthentication()
  const {
    EligibilityForm,
    setIdElegibilityForm,
    setEligibilityForm,
    idElegibilityForm,
  } = useFormElegibilidad()

  const history = useHistory()

  // useEffect(() => {
  //   setFetchRequest(['create_form'])
  // }, [])

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Entendido',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        setEligibilityForm([])
        history.push('/')
      }
    })
  }

  const [loadingSave, setLoadingSave] = useState(false)

  const saveFormElegibilidad = async () => {
    try {
      if (
        idElegibilityForm === 0 ||
        idElegibilityForm === null ||
        idElegibilityForm === ''
      ) {
        EligibilityForm.IdElegibilityAnswer = 0
      }
      const idUser2 = '5f6c28c5-62f8-4a84-ba26-b55e319d440f'
      const eligibilityBorrador = {
        ...EligibilityForm,
        IdUserAzureB2C: idUser2,
        IdFormAction: 16,
        Draft: true,
      }
      const response = await saveElegibilityForm(eligibilityBorrador)

      if (response.Code === 200) {
        setIdElegibilityForm(response.Data.idElegibilityForm)
        const mensaje = `Formulario De Elegibilidad guardado exitosamente`
        Swal.fire({
          title: `Guardado`,
          text: `${mensaje}`,
          icon: 'success',
          confirmButtonColor: '#28a745',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Entendido',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            // setEligibilityForm({
            //   ...EligibilityForm,
            //   IdElegibilityAnswer: 0,
            // })
            history.push('/')
          }
        })
      } else {
        setLoadingSave(false)

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error al intentar guardar el formulario',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Reintentar',
          footer:
            '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div
        id="wizard-form"
        style={{
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
        }}
      >
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Formulario Elegibilidad de Inversiones para Financiamiento
                </label>
              </div>
              <label className="formDescription">
                Rellene la información requerida para registrar el formulario
              </label>
            </Grid>
          </Grid>
          {/* <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>
            <Grid item>
              <div
                onClick={() => !loadingSave && saveFormElegibilidad()}
                data-tip
                data-for="savePop"
                style={{
                  backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <SaveIcon />
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Guardar Borrador</span>
              </ReactTooltip>
            </Grid>
          </Grid> */}
        </div>

        <Grid
          container
          spacing={1}
          style={{ marginTop: '18px', marginBottom: '36px' }}
        >
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 1
                ? // step === 1
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 1</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 2
                ? // step === 2
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 2</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 3
                ? // step === 3
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 3</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 4
                ? // step === 4
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 4</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 5
                ? // step === 5
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 5</label>
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            className={`${
              state.step === 6
                ? // step === 6
                  `stepper__title-active`
                : `stepper__title-inactive`
            }`}
          >
            <label>SECCIÓN 6</label>
          </Grid>
        </Grid>

        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                width: '80%',
                height: '80vh',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CircularProgress />
              </Box>
            </div>
          }
        >
          <StepWizard initialStep={1}>
            <ElegibilidadSec1 />
            <ElegibilidadSec2 />
            <ElegibilidadSec3 />
            <ElegibilidadSec4 />
            <ElegibilidadSec5 />
            <ElegibilidadSec6 />
          </StepWizard>
        </Suspense>
      </div>
    </>
  )
}

export default ElegibilidadForm
